import { render, staticRenderFns } from "./MessageTypeIconSelect.vue?vue&type=template&id=94e32962&scoped=true&"
import script from "./MessageTypeIconSelect.vue?vue&type=script&lang=js&"
export * from "./MessageTypeIconSelect.vue?vue&type=script&lang=js&"
import style0 from "./MessageTypeIconSelect.vue?vue&type=style&index=0&id=94e32962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e32962",
  null
  
)

export default component.exports